import { Box, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import { Context } from "contexts/contextState";
import { Course } from "models/Course";
import { VIDEO_ENUM, Video } from "models/Video";
import PropTypes from "prop-types";
import { useContext, useState } from "react";
import { errorAlert, successAlert } from "views/components/Alerts";

export function DeleteVideoModal(props) {
  const { context } = useContext(Context);
  const [processing, setProcessing] = useState(false);

  async function handleDeleteVideo() {
    setProcessing(true);
    try {
      const course = new Course(props.course);
      const deletedCourse = new Video(props.video);
      if (deletedCourse.privacy == VIDEO_ENUM.PRIVATE) {
        await context.fileStorageRepository.delete(deletedCourse.videoReference?.id);
      }
      course.videos = course.videos.filter(video => !(video.id == deletedCourse.id));
      await context.courseRepository.save(course);
      successAlert("Success!", "The video has been deleted.").then(() => {
        window.location.reload();
      });
      props.onClose();
    } catch (error) {
      console.log("handleDeleteVideo", error);
      errorAlert("Error!", "Failed to delete a video in our database. Please check your connection and try again. If the issue persists, please contact our support team for assistance.");
    } finally {
      setProcessing(false);
    }
  }

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogTitle>
        Are you certain you want to delete this video?
      </DialogTitle>
      <DialogContent>
        <SoftTypography variant="body2">
          If you delete this video <b>{props.video?.title || ""}</b>, it cannot be recovered. <br />Are you sure you want to proceed?
        </SoftTypography>
        <br />
        <SoftTypography variant="body2">
          Click the <b>Delete</b> button to confirm or <b>Cancel</b> to go back.
        </SoftTypography>
      </DialogContent>
      <DialogActions>
        <Box display="flex" justifyContent="space-between" flex="1">
          <SoftButton variant="text" color="error"
            onClick={handleDeleteVideo}
            disabled={!(context.permission?.root || context.permission?.course?.delete)}
          >
            Delete
          </SoftButton>
          <SoftButton variant="text" color="info" onClick={props.onClose} disabled={processing}>Cancel</SoftButton>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

DeleteVideoModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  video: PropTypes.object.isRequired,
  course: PropTypes.object.isRequired,
};